// Segurança do QZ Tray — ASSINATURA das requisições.
//
// Com um certificado que o QZ Tray confia + assinatura válida, o QZ passa a
// aceitar o site sem o prompt "Allow/Block" (era o que causava o
// "Connection blocked by client"). A assinatura é feita com WebCrypto (nativo),
// sem dependências externas.
//
// AVISO DE SEGURANÇA: certificado/chave próprios "Cliente Fiel" (self-signed).
// Para o QZ confiar SILENCIOSAMENTE neste certificado (sem prompt Allow/Block),
// adicione o certificado abaixo como OVERRIDE na instalação do QZ Tray:
//   - copie o clientefiel-cert.pem para a pasta do QZ (ex.: override.crt)
//   - em qz-tray.properties defina: authcert.override=<caminho>/override.crt
//   - reinicie o QZ Tray.
// A chave privada NÃO deve ficar no bundle em produção — o ideal é assinar as
// requisições no BACKEND. Mantida aqui apenas para o fluxo atual do painel.

const qz = require("qz-tray")

export const CERTIFICADO = `-----BEGIN CERTIFICATE-----
MIID1zCCAr+gAwIBAgIUP8TPQn0JFFQzur656wlz3IUIjHUwDQYJKoZIhvcNAQEN
BQAwezELMAkGA1UEBhMCQlIxFTATBgNVBAoMDENsaWVudGUgRmllbDEVMBMGA1UE
CwwMQ2xpZW50ZSBGaWVsMRUwEwYDVQQDDAxDbGllbnRlIEZpZWwxJzAlBgkqhkiG
9w0BCQEWGGFwcGNsaWVudGVmaWVsQGdtYWlsLmNvbTAeFw0yNjA3MTEyMzA5NTFa
Fw00NjA3MDYyMzA5NTFaMHsxCzAJBgNVBAYTAkJSMRUwEwYDVQQKDAxDbGllbnRl
IEZpZWwxFTATBgNVBAsMDENsaWVudGUgRmllbDEVMBMGA1UEAwwMQ2xpZW50ZSBG
aWVsMScwJQYJKoZIhvcNAQkBFhhhcHBjbGllbnRlZmllbEBnbWFpbC5jb20wggEi
MA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCttVpwpTgehEpoLljUNieRdK76
D/HjOvPwK/HyYa8wuMRmNLBUE06uytmg3WoIEfvjo6aItyr8V0V3tJfL+Coc16uw
CS3OboPu2JP4waWUX8hXKZw4qz5Nhyib8/7iGVXBjQAZg5tyA9iM6elPcAbwD24n
s45/O1OtsdIpOYGwo3HGltEhuUvncQkLO/t9K6vhXEu+7BP34q1Rza77Dy0vKkus
c4tD0Hd1SAIzAYKG13CI33o1wUhb7cLQjJraYPgrS9OClLjuKwUbtdb6klDGeMUE
Z890mIgUxXXqbdCajKM8qJaupCBw8ua3eei7UfhGEWBp0yze4HzQEeFE7+uNAgMB
AAGjUzBRMB0GA1UdDgQWBBSqByKa1iPf1apy5BznJCpVS/ucMTAfBgNVHSMEGDAW
gBSqByKa1iPf1apy5BznJCpVS/ucMTAPBgNVHRMBAf8EBTADAQH/MA0GCSqGSIb3
DQEBDQUAA4IBAQAGKp3VUZjRjbzoCCRAPEo0U3TDai9SyNW0SOQIvOrgvmyWDGID
2TYaWDc/bEN2A5nHUfUegAIqmA+PUZPnbfHWfCd7Cl6HvT+wjs8AYrbN03MfwxXP
CSs4WtRvNsNoG3wmcpTkEXX/zgtusWicsifb2jOUID31bLIYIgtozGv4Ff6PIp+S
LsmqgJXo1hKBzXp0hGz05jLRH+U8Ot4bVMwM5qHN0qRyqYoasDqgz6wKdm5Hvoa3
OKYhut8+YlRzsqqpiXqvu7D18ArqbZVOSoBO8ikbzpKOZ2Yat5wSv5ljvXyl/N46
7ZFtL50K2DPPprmDUPG7r1kgawtQj2kfpjnS
-----END CERTIFICATE-----`

const CHAVE_PRIVADA = `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCttVpwpTgehEpo
LljUNieRdK76D/HjOvPwK/HyYa8wuMRmNLBUE06uytmg3WoIEfvjo6aItyr8V0V3
tJfL+Coc16uwCS3OboPu2JP4waWUX8hXKZw4qz5Nhyib8/7iGVXBjQAZg5tyA9iM
6elPcAbwD24ns45/O1OtsdIpOYGwo3HGltEhuUvncQkLO/t9K6vhXEu+7BP34q1R
za77Dy0vKkusc4tD0Hd1SAIzAYKG13CI33o1wUhb7cLQjJraYPgrS9OClLjuKwUb
tdb6klDGeMUEZ890mIgUxXXqbdCajKM8qJaupCBw8ua3eei7UfhGEWBp0yze4HzQ
EeFE7+uNAgMBAAECggEAS65MlfFVzu3iIRu4NdTWTmgg5+/UeiSwLP5obiqjEj4d
y02/WRIEYOEeChkNXjC/psEhCEWNY9199ZZn4EThzCkmsw58t4is0H3pkiKESm2k
slz9pC7veQWe6rtWXBmfpDETTwpoyjbkvRgYPzTWwPZoDsILHmGxpmZn4vAcEeGb
0nA68+nF7FFMbtU2kWLjp9A7NUCly1O5LBi9Hiz/BLmCL2Rf+M7H4ThazHyvk8uT
OYDKH293ljXijUXwqUitCLL8as0ShANtUAO5XI4lMiGzXnBNT0ByXe7YSe/+4fbr
dfxk2Szppk4wXRnZmq3doVS0+AOBoTbofrn90+ZJXQKBgQDgNarbFFxMmMdTEptf
YnXBxB3oZcuqeoqv8QtM0hnwVs/BXILjlVyx0V2oAOQOe3rudecK3vtJmoNiatXl
qOygikEyn88ChhkOtRcJ+n/wGyVCr7w/mk3bZG1iJi+OJX0mld3MoP5dHproip11
2Rz0qpAECUJ9GbJA0uk4SqjzFwKBgQDGVplNVTMXurCNz/Ge+hte9X/Y2W/t3qB0
qQ0cfyLTsmorH5m6fXKONHEXBol49AyIe+NOUOL2oF9VNOP+ml54zt2OcfOUIStV
LuOAkIGJoaTjFEoyHpPI9F2UiPxc2lb57BugUkqsFJRzva76Gc8EPgQdecyyogDF
fc3ywg+M+wKBgG7RF8mAnr4dJSeiIrlaaOmEjWO4LJnuR23+rZ8imT95KOZhWzAx
OseIu8m15wJhdbk2/SMaYwlWHWofc+k3PP18WA01f5O3w9rJFsIP1fxO7nOveFPX
aHPvh0Djrs2LKfhQSnhBend8EQSuvnTpAq7LPrNAAGTktn3jwPHZtPexAoGBAIrG
zT1u//D6j86qUUYLeltXK71vZwHpZBw8rQ/jZVr6246Q7d+vJxiZWQfjaw1Wte5J
wSJrNmOakxnriBv9p1ygYiXpVaWwD8HqrQSoF/tVPyokaEXpXz6cvV3Q+8N8gp8c
tbfX3KfLPpQ9hNE6fb9aJUb6kl/rOt70x8W0Q21BAoGAansKB+uPM2zDHzDyv0dW
ms2m5yyGMwSRApGMiqeh5qcaGqndhktzGvAuD7aXjTsVLmHvvRnKbzJUnbKS5vmh
qm8u1pWDjktU6ak5bFeMViO6gR/j8AVBDoLBtfACWCQYJOnXlm4TZV6cYapZxRi6
QOE2+q/r1CNEJ9pW/byLlqU=
-----END PRIVATE KEY-----`

let chavePromise = null
function importarChave() {
    if (!chavePromise) {
        const b64 = CHAVE_PRIVADA.replace(/-----[^-]+-----/g, "").replace(/\s+/g, "")
        const der = Uint8Array.from(atob(b64), c => c.charCodeAt(0))
        chavePromise = crypto.subtle.importKey(
            "pkcs8",
            der.buffer,
            { name: "RSASSA-PKCS1-v1_5", hash: "SHA-512" },
            false,
            ["sign"]
        )
    }
    return chavePromise
}

async function assinar(toSign) {
    const chave = await importarChave()
    const assinatura = await crypto.subtle.sign(
        "RSASSA-PKCS1-v1_5",
        chave,
        new TextEncoder().encode(toSign)
    )
    let bin = ""
    const bytes = new Uint8Array(assinatura)
    for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i])
    return btoa(bin)
}

let configurado = false

/** Configura o certificado + assinatura do QZ (idempotente). */
export function configurarSegurancaQz() {
    if (configurado) return
    configurado = true
    try {
        qz.security.setSignatureAlgorithm("SHA512")
        qz.security.setCertificatePromise(resolve => resolve(CERTIFICADO))
        qz.security.setSignaturePromise(toSign => (resolve, reject) => {
            assinar(toSign).then(resolve).catch(reject)
        })
    } catch (e) {
        /* ambiente sem qz.security/crypto — segue em modo não-assinado */
    }
}
